module.exports = __webpack_public_path__ + "img/19-doc-publicacoes-lista.0cbc566e.png";